import React from "react";
import styled from "styled-components";
import MiniProjectCard from "./MiniProjectCard";
import MiniProjectsData from "./MiniProjectsData";
import { useLanguage } from "../../contexts/LanguageContext";
import { getMiniProjectTranslation } from "../../translations/miniProjectsAndJS30";

function Section() {
  const { language } = useLanguage();
  return (
    <Wrap>
      <ItemText>
        <h1>{getMiniProjectTranslation(language, "title")}</h1>
      </ItemText>
      <Cards>
        {MiniProjectsData.map((project, index) => (
          <MiniProjectCard key={index} {...project} />
        ))}
      </Cards>
    </Wrap>
  );
}

export default Section;

const Cards = styled.div`
  min-width: 100vw;
  min-height: 80vh;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  flex-wrap: wrap;
`;

const Wrap = styled.div`
  min-width: 100vw;
  min-height: 100vh;
  background-color: rgba(248, 241, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 490px) {
    overflow-x: hidden;
  }
`;

const ItemText = styled.div`
  width: 100vw;
  padding-top: 12vh;
  justify-content: center;
  text-align: center;
  color: black;
  display: flex;

  h1 {
    margin-top: -7px;
    margin-right: 2px;
    @media (max-width: 768px) {
      font-size: 24px;
      margin-top: -4px;
    }
  }
`;
